import React from 'react';
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Colors } from '../../../../scss/common/style';

import { transformLabels } from '../../../../utils/misc';
import ErrorLabel from '~/src/components/common/forms/ErrorLabel';

interface Option {
  label: string;
  value: string | number;
  color?: string;
}

interface ButtonGroupComponentProps {
  onChange: (value: string | number) => void;
  name: string;
  initialValue?: string | number;
  options: Option[];
  cols?: number;
  label?: string;
  touched?: Record<string, boolean>;
  errors?: Record<string, string>;
  buttonsPerRow?: number;
}

export default function InventoryBtnGroupComponent({
  onChange,
  name,
  initialValue = '',
  options,
  cols = 6,
  label = '',
  touched = {},
  errors = {},
  buttonsPerRow = 5,
}: ButtonGroupComponentProps): JSX.Element {
  return (
    <Wrapper className={`form-group col-sm-${cols}`}>
      <TiitleButtons className="ak-form-labels" htmlFor={`id-${name}`}>
        {label || transformLabels(name)}
      </TiitleButtons>
      <ToggleButtonGroupS
        style={{ width: '100%', flexWrap: 'wrap' }}
        id={`id-${name}`}
        aria-label={`Choice of ${name}`}
        type="radio"
        name={name}
        onChange={onChange}
        defaultValue={initialValue}
      >
        {options.map((item, i) => {
          return (
            <ToggleButton
              variant="outline-primary"
              style={{
                width: `${100 / options.length}%`,
                backgroundColor: item.color,
                borderColor: item.color,
                color: item.DarkText ? '#000' : '#fff',
              }}
              key={`${item.value}`}
              id={i}
              value={item.value}
            >
              {item.label}
            </ToggleButton>
          );
        })}
      </ToggleButtonGroupS>
      {touched && touched[name] && errors[name] && <ErrorLabel error={errors[name]} />}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 15px !important;
  background: #ffffff;
  border-radius: 18px;
`;

const TiitleButtons = styled.label`
  color: #9b9b9b !important;
`;

const ToggleButtonGroupS = styled(ToggleButtonGroup)`
label {
  display: flex;
  align-items: center;
  justify-content: center;
  border 3px solid #fff !important;
  background: #E4E4E4;
  color: #fff;
  height: 58px;
}
label:hover {
  background: #EEEEEE!important;
  border-color: #EEEEEE!important;
  color:${Colors.darkBrown}!important
}
label:focus {
  box-shadow: 0 !important;
}
  .active {
    border-color: ${Colors.darkBrown}!important;
    color:#fff!important;
    padding: 1px;
}

  }
  &.btn-primary {
    background: red !important;
  }
`;
